<template>
  <v-app id="ilog">
    <!-- Side Bar Menu -->
    <v-navigation-drawer
      id="nav-bar"
      v-model="drawer"
      dark
      fixed
      app
      floating
      temporary
    >
      <v-list>
        <div id="menu-sidebar">
          <v-list-tile-content id="group_logo_menu">
            <img
              src="../assets/img/favicon2.png"
              alt="ilog_logo"
              id="ilog_logo_menu"
            />
          </v-list-tile-content>
          <v-flex style="position: absolute; top: 8px; right: 0;">
            <v-btn
              flat
              icon
              style="outline: none;"
              @click.stop="drawer = !drawer"
            >
              <v-icon>arrow_back_ios_new</v-icon>
            </v-btn>
          </v-flex>
          <!-- iLog TCCA Menu -->
          <v-list-tile-content id="group_menu">
            <v-list-tile-title style="pointer-events: none;"
              >iLog</v-list-tile-title
            >
          </v-list-tile-content>
          <v-list-tile
            v-if="role !== 'AIS_Dashboard'"
            @click="toDashboard"
            class="tile"
            :style="
              $router.history.current.name === 'dashboard'
                ? 'background-color: #149AEC;'
                : ''
            "
          >
            <v-list-tile-action>
              <v-icon>dashboard</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Dashboards</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            v-if="role !== 'AIS_Dashboard'"
            :disabled="isExpired"
            @click="toAlertHistoryTCCA"
            class="tile"
            :style="
              $router.history.current.name === 'alertHistorytcca'
                ? 'background-color: #149AEC;'
                : ''
            "
          >
            <v-list-tile-action>
              <v-icon :disabled="isExpired">history</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Alert History</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <!-- iLog PDPA Menu -->
          <v-flex v-if="pdpaMenu">
            <div id="space-menu"></div>
            <v-list-tile-content id="group_menu">
              <v-list-tile-title style="pointer-events: none;"
                >PDPA</v-list-tile-title
              >
            </v-list-tile-content>
            <v-list-tile
              v-if="role !== 'AIS_Dashboard'"
              @click="todashboardPDPA"
              class="tile"
              :style="
                $router.history.current.name === 'dashboardpdpa'
                  ? 'background-color: #149AEC;'
                  : ''
              "
            >
              <v-list-tile-action>
                <v-icon>dashboard</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Dashboards</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              v-if="pdpaMenuSetting"
              :disabled="isExpired"
              @click="toWhitelist"
              class="tile"
              :style="
                $router.history.current.name === 'whiteList'
                  ? 'background-color: #149AEC;'
                  : ''
              "
            >
              <v-list-tile-action>
                <v-icon :disabled="isExpired">manage_accounts</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Whitelist</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              v-if="role !== 'AIS_Dashboard'"
              :disabled="isExpired"
              @click="toAlertHistoryPDPA"
              class="tile"
              :style="
                $router.history.current.name === 'alertHistorypdpa'
                  ? 'background-color: #149AEC;'
                  : ''
              "
            >
              <v-list-tile-action>
                <v-icon :disabled="isExpired">history</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Alert History</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-flex>
          <!-- Tools Menu -->
          <div id="space-menu"></div>
          <v-list-tile-content id="group_menu">
            <v-list-tile-title style="pointer-events: none;"
              >Tools</v-list-tile-title
            >
          </v-list-tile-content>
          <v-list-tile
            v-if="role !== 'AIS_Dashboard'"
            :disabled="isExpired"
            @click="toSearch"
            class="tile"
            :style="
              $router.history.current.name === 'raw'
                ? 'background-color: #149AEC;'
                : ''
            "
          >
            <v-list-tile-action>
              <v-icon :disabled="isExpired">search</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Search</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            v-if="role !== 'AIS_Dashboard'"
            :disabled="isExpired"
            @click="toAlert"
            class="tile"
            :style="
              $router.history.current.name === 'alert'
                ? 'background-color: #149AEC;'
                : ''
            "
          >
            <v-list-tile-action>
              <v-icon :disabled="isExpired">notifications_active</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Alert Condition</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <div id="space-menu"></div>
          <!-- About iLog Menu -->
          <v-list-tile-content id="group_menu">
            <v-list-tile-title style="pointer-events: none;"
              >About</v-list-tile-title
            >
          </v-list-tile-content>
          <v-list-tile
            v-if="role !== 'AIS_Dashboard'"
            @click="toLicense"
            class="tile"
            :style="
              $router.history.current.name === 'license'
                ? 'background-color: #149AEC;'
                : ''
            "
          >
            <v-list-tile-action>
              <v-icon>info</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>License</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <!-- Community iLog Menu -->
          <!-- <v-list-tile-content  id="group_menu">
          <v-list-tile-title style="pointer-events: none;">Community</v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile v-if="role !== 'AIS_Dashboard'" @click="toRequest" class="tile" >
          <v-list-tile-action>
            <v-icon>flag</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Request Feature</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="role !== 'AIS_Dashboard'" @click="toReport" class="tile" >
          <v-list-tile-action>
            <v-icon>report</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Report Problem</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile> -->
        </div>
        <!-- Administrator Menu -->
        <v-list-tile-content v-if="role === 'management'" id="group_menu">
          <v-list-tile-title style="pointer-events: none;"
            >Support</v-list-tile-title
          >
        </v-list-tile-content>
        <v-list-tile
          v-if="role === 'management'"
          @click="toSupport"
          class="tile"
          :style="
            $router.history.current.name === 'support'
              ? 'background-color: #149AEC;'
              : ''
          "
        >
          <v-list-tile-action>
            <v-icon>settings</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Administrator</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <!--<v-list-group>
          <v-list-tile slot="activator">
            <v-list-tile-action>
              <v-icon>assessment</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Usecase</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="$router.replace({ name: 'uba' })" class="grey darken-4">
            <v-list-tile-action>
              <v-icon>account_box</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title class="submenu">UBA</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="$router.replace({ name: 'configChange' })" class="grey darken-4">
          <v-list-tile-action>
            <v-icon>build</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="submenu">Config Change</v-list-tile-title>
          </v-list-tile-content>
          </v-list-tile>
        </v-list-group>-->
        <!-- <v-list-tile
          v-if="role !== 'AIS_Dashboard'"
          :disabled="isExpired"
          @click="toSearch">
          <v-list-tile-action>
            <v-icon>search</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Search</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile> -->
        <!-- <v-list-tile
          :disabled="isExpired"
          @click="$router.replace({ name: 'raw', params: { isExpired } })">
          <v-list-tile-action>
            <v-icon>search</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Search</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile> -->
        <!-- <v-list-tile
          v-if="role !== 'AIS_Dashboard'"
          :disabled="isExpired"
          @click="toAlert">
          <v-list-tile-action>
            <v-icon>notifications</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Alert</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile> -->
        <!-- <v-list-tile v-if="pdpacontrol" @click="toWhitelist">
            <v-list-tile-action>
              <v-icon>list_alt</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>WhiteList</v-list-tile-title>
            </v-list-tile-content>
        </v-list-tile> -->
        <!-- <v-list-tile v-if="role !== 'AIS_Dashboard'" @click="toLicense">
          <v-list-tile-action>
            <v-icon>book</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>License</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile> -->
        <!-- <v-list-tile v-if="role === 'AIS_Dashboard'" @click="$router.push({ name: 'allDashboard' })">
          <v-list-tile-action>
            <v-icon>edit</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>All Dashboard</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile> -->
        <!-- Administrator Menu -->
        <!-- <div id="space-menu"></div>
        <v-list-tile-content v-if="role === 'management'"  id="group_menu">
          <v-list-tile-title style="pointer-events: none;">Support iLog</v-list-tile-title>
        </v-list-tile-content> -->
        <!-- <v-list-group v-if="role === 'management' || role === 'dashboard'">
          <v-list-tile slot="activator" v-if="role === 'management' || role === 'dashboard'" >
            <v-list-tile-action>
              <v-icon>settings</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Administrator</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile class="tile" @click="$router.replace({ name: 'generateUser' })" v-if="role === 'management'" @click.native="navMenu = 'Administrator / Generate User'">
            <v-list-tile-action>
              <v-icon>account_box</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Create New User</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile  class="tile" @click="$router.replace({ name: 'customerDetail' })" v-if="role === 'management'" @click.native="navMenu = 'Administrator / Customer Detail'">
            <v-list-tile-action>
              <v-icon>account_circle</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Customer Detail</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile class="tile" @click="$router.replace({ name: 'allDashboard' })" v-if="role === 'management' || role === 'dashboard'" @click.native="navMenu = 'Administrator / All Dashboard'">
            <v-list-tile-action>
              <v-icon>edit</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>All Dashboard</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile class="tile" @click="$router.replace({ name: 'pdpacontrol' })" v-if="role === 'management'" @click.native="navMenu = 'Administrator / PDPA Control'">
            <v-list-tile-action>
              <v-icon>fact_check</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>PDPA Control</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile class="tile" @click="$router.replace({ name: 'monitor' })" v-if="role === 'management'" @click.native="navMenu = 'Administrator / Monitor Docker'">
            <v-list-tile-action>
              <v-icon>access_alarm</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Monitor Docker</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile class="tile" @click="$router.replace({ name: 'monitorVolume' })" v-if="role === 'management'" @click.native="navMenu = 'Administrator / Monitor Disk'">
            <v-list-tile-action>
              <v-icon>access_alarm</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Monitor Disk</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group> -->
      </v-list>
    </v-navigation-drawer>
    <!-- <v-dialog v-model="showDialogTerminal" full-width fullscreen>
      <terminal @close="showDialogTerminal = false" />
    </v-dialog> -->
    <!-- Top Bar -->
    <v-toolbar
      app
      dense
      dark
      id="tool-bar"
      v-if="this.$route.path !== '/app/register'"
    >
      <v-toolbar-side-icon @click.stop="openMenu" style="outline: none;">
      </v-toolbar-side-icon>
      <button @click="toHome" style="outline: none;">
        <img
          src="../assets/img/favicon2.png"
          alt="ilog_logo"
          style="width: 27px; height: 25px; margin-right: 5px;"
        />
      </button>
      <span style="pointer-events: none; margin-left: 1px;">{{ navMenu }}</span>
      <v-spacer />
      <v-menu
        v-if="!isExpired"
        offset-y
        origin="center center"
        :close-on-content-click="false"
      >
        <template #activator="{ on: menu }">
          <v-tooltip bottom>
            <template #activator="{ on: tooltip }">
              <!-- eslint-disable vue/valid-v-on -->
              <!-- eslint-disable vue/no-parsing-error -->
              <v-btn
                flat
                icon
                id="menu-notic"
                @click="toSetNotification(5), clickNotification()"
                style="outline: none;"
                v-on="{ ...tooltip, ...menu }"
              >
                <!-- eslint-enable -->
                <v-badge right overlap color="orange darken-3">
                  <v-layout
                    v-if="badgeNoti > 0"
                    slot="badge"
                    align-center
                    justify-center
                  >
                    <span
                      v-if="badgeNoti < 1000"
                      slot="badge"
                      style="font-size: 12px;"
                      >{{ badgeNoti }}</span
                    >
                    <span v-else slot="badge" style="font-size: 10px;">
                      999+
                    </span>
                  </v-layout>
                  <v-icon>notifications</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <span>Notification</span>
          </v-tooltip>
        </template>
        <notification
          @clearNoti="clearNotification"
          @delNoticAll="delNotificationAll"
          @setbadge="badgeNoti += 1"
          @delNoti="badgeNoti -= 1"
          @seemore="shownNoticficationMore"
          @setNev="toLog"
          @reload="toSetNotification(5)"
          :name="names"
        />
      </v-menu>
      <!-- <v-tooltip bottom id="menu-newupdate">
        <v-btn flat icon slot="activator" data-canny-changelog style="outline: none;">
          <v-icon>cast_connected</v-icon>
        </v-btn>
        <span>News update</span>
      </v-tooltip> -->
      <v-tooltip bottom>
        <v-btn
          id="menu-manual"
          flat
          icon
          slot="activator"
          style="outline: none;"
          @click="forum"
        >
          <v-icon>help</v-icon>
        </v-btn>
        <span>Manual</span>
      </v-tooltip>
      <v-tooltip bottom>
        <v-btn
          id="menu-contact"
          flat
          icon
          slot="activator"
          style="outline: none;"
          @click="openChat"
        >
          <v-icon>chat</v-icon>
        </v-btn>
        <span>Chat Support</span>
      </v-tooltip>
      <!-- <v-tooltip bottom>
        <v-btn flat icon slot="activator" style="outline: none;" @click="logout">
          <v-icon>exit_to_app</v-icon>
        </v-btn>
        <span> Log out </span>
      </v-tooltip> -->
      <v-menu
        transition="slide-y-transition"
        offset-y
        :close-on-content-click="false"
      >
        <template #activator="{ on: menu }">
          <v-tooltip bottom>
            <template #activator="{ on: tooltip }">
              <v-btn
                flat
                icon
                style="outline: none;"
                v-on="{ ...tooltip, ...menu }"
              >
                <v-icon>account_circle</v-icon>
              </v-btn>
            </template>
            <span>Account</span>
          </v-tooltip>
        </template>
        <v-list style="min-width: 150px;">
          <v-list-tile>
            <v-list-tile-title style="height: 51px;">
              <v-flex>
                <v-icon size="19" style="color:#757575;">business</v-icon>
                <span
                  style="margin-left: 3px; color:#757575; font-size: 14px;"
                  >{{ customerName }}</span
                >
              </v-flex>
              <v-flex style="margin-top: 3px;">
                <v-icon size="18" style="color:#757575;">person_outline</v-icon>
                <span
                  style="margin-left: 3px; color:#757575; font-size: 14px;"
                  >{{ username }}</span
                >
              </v-flex>
            </v-list-tile-title>
            <!-- <v-list-tile-title v-else>
              <v-icon size="18" style="color:#757575;">person_outline</v-icon>
              <span style="margin-left: 2px; color:#757575; font-size: 14px;">{{username}}</span>
            </v-list-tile-title> -->
          </v-list-tile>
          <v-divider
            class="mx-1 my-2"
            inset
            style="position:relative; top: 1px; left: 30px;"
          />
          <v-list-tile @click="contact">
            <v-list-tile-title>
              <v-icon size="18" style="color:#757575;">support_agent</v-icon>
              <span style="margin-left: 2px; color:#757575; font-size: 14px;"
                >Contact</span
              >
            </v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="logout">
            <v-list-tile-title>
              <v-icon size="18" style="color:#757575;">exit_to_app</v-icon>
              <span style="margin-left: 2px; color:#757575; font-size: 14px;"
                >Log Out</span
              >
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <v-content id="content">
      <router-view @toNotification="toNotification"></router-view>
    </v-content>
    <!-- dialog contect us -->
    <div class="text-xs-center">
      <v-dialog v-model="isDialogContectShown" width="800">
        <v-card class="contactus">
          <v-btn
            icon
            @click="isDialogContectShown = false"
            style="position: absolute; right:0; outline: none; color: #EEEEEE;"
          >
            <v-icon>close</v-icon>
          </v-btn>
          <v-card-text class="text-md-left">
            <v-layout
              column
              ml-4
              class="font-weight-regular"
              style="margin-top: 60px;"
            >
              <img :src="imgContact" alt="contact" class="img-contact" />
              <v-flex row mb-5>
                <v-icon
                  class="icon-contactus"
                  size="35"
                  style="position: relative; bottom: 5px;"
                  >home</v-icon
                >
                <span class="title-contact">Office address : </span>
                <span class="detail-contact"
                  >2521/7 Biztown LatPhrao ถ. ลาดพร้าว แขวง คลองเจ้าคุณสิงห์
                  <br />
                  เขตวังทองหลาง กรุงเทพมหานคร 10310</span
                >
              </v-flex>
              <v-flex row mb-5>
                <v-icon class="icon-contactus" size="35">email</v-icon>
                <span class="title-contact">E-mail : </span>
                <span class="detail-contact">ilogsupport@ragnar.co.th</span>
              </v-flex>
              <v-flex row mb-5>
                <v-icon class="icon-contactus" size="35">phone_in_talk</v-icon>
                <span class="title-contact">Tel. : </span>
                <span class="detail-contact">06-1391-4119</span>
              </v-flex>
              <v-flex row mb-5>
                <v-icon
                  class="icon-contactus"
                  size="35"
                  style="position: relative; bottom: 5px;"
                  >perm_contact_calendar</v-icon
                >
                <span class="title-contact">สามารถติดต่อได้ในเวลาทำการ : </span>
                <span class="detail-contact"
                  >จันทร์ - ศุกร์ เวลา 08.30 น. - 17.30 น. <br />
                  (ยกเว้นวันหยุดราชการ)</span
                >
              </v-flex>
              <!-- <v-flex row  mb-0>
                      <v-btn
                        round
                        style="outline: none; text-transform: capitalize;"
                        class="light-blue darken-3"
                        @click="openChat"
                        dark
                      >
                        <v-icon size="23" class="icon-contactus">support_agent</v-icon>
                        <span style="margin-left: 5px; color: #EEEEEE;">Live chat support</span>
                      </v-btn>
                    </v-flex> -->
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <v-tour
      name="recommand-tour"
      :steps="steps"
      :options="stepOptions"
      :callbacks="stepCallbacks"
    >
      <template slot-scope="tour">
        <transition name="fade"></transition>
        <v-step
          v-if="tour.steps[tour.currentStep]"
          :key="tour.currentStep"
          :step="tour.steps[tour.currentStep]"
          :previous-step="tour.previousStep"
          :next-step="tour.nextStep"
          :stop="tour.stop"
          :skip="tour.skip"
          :is-first="tour.isFirst"
          :is-last="tour.isLast"
          :labels="tour.labels"
          :highlight="tour.highlight"
          class="tour-body"
        >
          <template>
            <v-layout slot="header" class="tour-header">
              <img
                v-if="tour.currentStep == 0"
                src="../assets/img/login/logo-ilog-256.png"
                alt="ilog_logo"
                style="width: 21px; height: 21px; position: relative; top: 5px; left: 25px;"
              />
              <v-icon
                v-if="tour.currentStep == 1"
                style="position: relative; left: 70px; color: #fff;"
                >notifications</v-icon
              >
              <!-- <v-icon v-if="tour.currentStep == 2" style="position: relative; left: 60px; color: #fff;">cast_connected</v-icon> -->
              <v-icon
                v-if="tour.currentStep == 2"
                style="position: relative; left: 90px; color: #fff;"
                >help</v-icon
              >
              <v-icon
                v-if="tour.currentStep == 3"
                style="position: relative; left: 60px; color: #fff;"
                >menu</v-icon
              >
              <v-icon
                v-if="tour.currentStep == 4"
                style="position: relative; left: 85px; color: #fff;"
                >chat</v-icon
              >
              <v-flex
                class="headline font-weight-light"
                v-html="tour.steps[tour.currentStep].header.title"
              ></v-flex>
            </v-layout>
            <v-layout slot="content" class="tour-content" column>
              <v-flex class="body-2 font-weight-light" my-2
                >( {{ tour.currentStep + 1 }} /
                {{ tour.steps.length }} )</v-flex
              >
              <v-flex
                class=" body-2 font-weight-light"
                v-html="tour.steps[tour.currentStep].content"
              ></v-flex>
            </v-layout>
            <v-layout
              slot="actions"
              fill-height
              align-center
              justify-center
              row
            >
              <v-flex v-if="tour.currentStep == 0" mt-2>
                <v-btn
                  @click="tour.nextStep"
                  class="tour-btn-start font-weight-regular"
                  block
                  >Start</v-btn
                >
                <button @click="tour.skip" class="tour-btn-skip">Skip</button>
              </v-flex>
              <v-flex v-else-if="!tour.isLast" column mt-3>
                <v-btn
                  @click="tour.previousStep"
                  class="tour-btn-back font-weight-regular"
                  round
                  >Back</v-btn
                >
                <v-btn
                  @click="tour.nextStep"
                  class="tour-btn-next font-weight-regular"
                  round
                  >Next</v-btn
                ><br />
                <button @click="tour.skip" class="tour-btn-skip">Skip</button>
              </v-flex>
              <v-flex v-else>
                <v-btn @click="tour.finish" class="tour-btn-finish" block
                  >Finish</v-btn
                >
              </v-flex>
            </v-layout>
          </template>
        </v-step>
      </template>
    </v-tour>
  </v-app>
</template>

<script>
import axios from "axios";
import notification from "@/components/notification";
import jwtDecode from "jwt-decode";
import { signOutRedirect } from "../../config/auth";
// import terminal from '@/components/terminal'

export default {
  name: "layout",
  components: {
    notification
    // terminal
  },
  props: {
    isExpired: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      navMenu: "iLog",
      sidebar: [],
      token: "",
      message: "",
      drawer: false,
      failureClass: "red darken-4",
      successClass: "white",
      tcca: true,
      badgeNoti: 0,
      username: "",
      customerName: "",
      role: "",
      names: [],
      showDialogTerminal: false,
      // pdpacontrol: false
      pdpaMenu: false,
      pdpaMenuSetting: false,
      user_id: "",
      recommend: false,
      showDialogNew: false,
      // isDialogNewFeatureShown: false,
      isDialogContectShown: false,
      ampid: "",
      imgContact: require("../assets/img/contact/ilog-contact.png"),
      stepOptions: {
        useKeyboardNavigation: true,
        highlight: true,
        labels: {
          buttonSkip: "ข้าม",
          buttonPrevious: "ย้อนกลับ",
          buttonNext: "ต่อไป",
          buttonStop: "สิ้นสุด"
        }
      },
      countNoti: 5,
      stepCallbacks: {
        onSkip: this.finishStepTour,
        onFinish: this.finishStepTour
      },
      steps: [
        {
          target: "#tool-bar",
          header: {
            title: "Get Started with iLog 2.6"
          },
          content: `<h5>ยินดีต้อนรับสู่ iLog เวอร์ชั่น 2.6</h5><span>เตรียมพบกับประสบการณ์การใช้งาน iLog เวอร์ชั่นใหม่<br>พร้อมฟีเจอร์ใหม่ๆ ได้แล้ววันนี้</span>`,
          params: {
            highlight: true,
            enableScrolling: false
          }
        },
        {
          target: "#menu-notic",
          header: {
            title: "เมนู Notifications"
          },
          content: `<span>คุณจะไม่พลาดทุกการแจ้งเตือนที่คุณได้ตั้งค่าไว้</span>`,
          params: {
            highlight: true,
            enableScrolling: false
          }
        },
        {
          target: "#menu-manual",
          header: {
            title: "เมนู Manual"
          },
          content: `<span>พบกับคู่มือที่จะช่วยให้ประสบการณ์การใช้งาน iLog ของคุณง่ายขึ้น</span>`,
          params: {
            highlight: true,
            enableScrolling: false
          },
          before: () => {
            this.drawer = false;
          }
        },
        {
          target: "#menu-sidebar",
          header: {
            title: "ปรับหน้าตาเมนูใหม่"
          },
          content: `<span>คุณจะพบกับหน้าตาเมนูใหม่ ใช้งานง่ายขึ้น รวมทั้งฟีเจอร์ใหม่ๆ</span><br><span>(ติดต่อ Support เพื่อขอรายละเอียดเพิ่มเติม)</span>`,
          params: {
            placement: "right",
            highlight: true,
            enableScrolling: true
          },
          before: () => {
            this.pdpaMenu = true;
            this.pdpaMenuSetting = true;
            this.drawer = true;
          }
        },
        {
          target: "#menu-contact",
          header: {
            title: "Support iLog "
          },
          content: `<span>ตุณสามารถติดต่อขอความช่วยเหลือได้ผ่านช่องทางต่างๆ</span><br><span>พวกเราทีมงาน iLog ยินดีให้บริการ</span>`,
          params: {
            highlight: true,
            enableScrolling: false
          },
          before: () => {
            this.token = sessionStorage.getItem("user-token");
            let decoded = jwtDecode(this.token);
            this.pdpaMenu = decoded.pdpacontrol.dashboard;
            this.pdpaMenuSetting = decoded.pdpacontrol.addlist;
            this.drawer = false;
          }
        }
      ]
    };
  },
  async created() {
    this.token = sessionStorage.getItem("user-token");
    let decoded = jwtDecode(this.token);
    this.ampid = decoded.ampid;
    this.username = decoded.username;
    this.customerName = decoded.customer_name;
    this.role = decoded.role;
    this.user_id = decoded._id;
    this.pdpaMenu = decoded.pdpacontrol.dashboard;
    this.pdpaMenuSetting = decoded.pdpacontrol.addlist;
    this.isExpired = decoded.isExpired;
    axios.defaults.headers.common["Authorization"] = this.token;
    // window.addEventListener('beforeunload', this.leaving())
    window.onbeforeunload = this.leaving();
    if (!this.isExpired) {
      try {
        let response = await axios.get(apiUrl + "/api/auth/layout");
        this.message = response.data;
      } catch (error) {
        this.message = "Unauthorized Access";
        this.$router.push({ name: "login" });
      }
      this.setNev();
      setTimeout(() => {
        this.toSetNotification(5);
      }, 1500);
      if (this.role === "user") {
        let response = await axios.post(apiUrl + "/api/status/recommend", {
          command: "get"
        });
        this.recommend = response.data.dashbordtcca;
      }
    }
    // document.getElementById('zsiq_float').addEventListener('click', () => {
    //   // eslint-disable-next-line
    //   let reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    //   let validateUser = reg.test(this.username)
    //   setTimeout(() => {
    //     document.getElementById('siqiframe').contentWindow.document.getElementById('visname').value = this.customerName
    //     if (validateUser) {
    //       document.getElementById('siqiframe').contentWindow.document.getElementById('visemail').value = this.username
    //     }
    //   }, 100)
    // })
  },
  mounted() {
    document.getElementById("zsiq_float").addEventListener("click", () => {
      // eslint-disable-next-line
      let reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
      let validateUser = reg.test(this.username);
      setTimeout(() => {
        document
          .getElementById("siqiframe")
          .contentWindow.document.getElementById(
            "visname"
          ).value = this.customerName;
        if (validateUser) {
          document
            .getElementById("siqiframe")
            .contentWindow.document.getElementById(
              "visemail"
            ).value = this.username;
        }
      }, 100);
    });
  },
  // mounted () {
  //   // // eslint-disable-next-line
  //   // Canny('initChangelog', {
  //   //   appID: '60a3219ace40ec1c2083b9c0',
  //   //   position: 'bottom',
  //   //   align: 'right'
  //   // })
  // },
  methods: {
    logout() {
      window.analytics.track(
        "[Tabbar][LogOut]",
        {},
        {
          integrations: {
            Amplitude: {
              session_id: this.ampid
            }
          }
        }
      );
      window.analytics.reset();
      sessionStorage.removeItem("user-token");
      axios.post(apiUrl + "/api/auth/logout");
      signOutRedirect();
      // this.$router.push({ name: "login" });
    },
    contact() {
      window.analytics.track(
        "[Tabbar][Contact]",
        {},
        {
          integrations: {
            Amplitude: {
              session_id: this.ampid
            }
          }
        }
      );
      this.isDialogContectShown = true;
      // window.open('https://ilog.ai', '_blank')
    },
    openChat() {
      window.analytics.track(
        "[Tabbar][Chat Support]",
        {
          value: {
            link: "https://docs.ilog.ai/ilog-user-guild/"
          }
        },
        {
          integrations: {
            Amplitude: {
              session_id: this.ampid
            }
          }
        }
      );
      // eslint-disable-next-line
      let reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
      let validateUser = reg.test(this.username);
      setTimeout(() => {
        document.getElementById("zsiq_float").click();
        document
          .getElementById("siqiframe")
          .contentWindow.document.getElementById(
            "visname"
          ).value = this.customerName;
        if (validateUser) {
          document
            .getElementById("siqiframe")
            .contentWindow.document.getElementById(
              "visemail"
            ).value = this.username;
        }
      }, 100);
    },
    forum() {
      window.analytics.track(
        "[Tabbar][Manual]",
        {
          value: {
            link: "https://docs.ilog.ai/ilog-user-guild/"
          }
        },
        {
          integrations: {
            Amplitude: {
              session_id: this.ampid
            }
          }
        }
      );
      window.open("https://docs.ilog.ai/ilog-user-guild/", "_blank");
    },
    openMenu() {
      // window.analytics.track('[Click][Menu]', {
      //   value: {
      //     menu: 'button'
      //   }
      // }, {
      //   integrations: {
      //     Amplitude: {
      //       'session_id': this.ampid
      //     }
      //   }
      // })
      setTimeout(() => {
        this.drawer = true;
      }, 100);
    },
    clickNotification() {
      if (this.countNoti === 5) {
        window.analytics.track(
          "[Tabbar][Notification]",
          {},
          {
            integrations: {
              Amplitude: {
                session_id: this.ampid
              }
            }
          }
        );
      } else if (this.countNoti === 100) {
        window.analytics.track(
          "[Tabbar][Notification][seemore]",
          {},
          {
            integrations: {
              Amplitude: {
                session_id: this.ampid
              }
            }
          }
        );
      }
    },
    toNotification(name) {
      // this.names.push({ name })
      // let datetime = new Date()
      // let day = ''
      // switch (datetime.getDay()) {
      //   case 1:
      //     day = 'Mon'
      //     break
      //   case 2:
      //     day = 'Tue'
      //     break
      //   case 3:
      //     day = 'Wed'
      //     break
      //   case 4:
      //     day = 'Thu'
      //     break
      //   case 5:
      //     day = 'Fri'
      //     break
      //   case 6:
      //     day = 'Sat'
      //     break
      //   case 0:
      //     day = 'Sun'
      //     break
      // }
      // let minutes = ''
      // if (datetime.getMinutes() < 10) {
      //   minutes = `0${datetime.getMinutes()}`
      // } else {
      //   minutes = `${datetime.getMinutes()}`
      // }
      // this.names.push(
      //   {
      //     _id: `${name}-01`,
      //     type: 'tcca',
      //     title: `You're Complete Create alert - ${day} ${datetime.getDate()} ${datetime.getHours()}:${minutes}`,
      //     description: `Check alert Name: ${name}`
      //   }
      // )
      this.badgeNoti = this.badgeNoti + 1;
    },
    async toSetNotification(e) {
      // if (e === 5) {
      //   window.analytics.track('[Tabbar][Notification]', {}, {
      //    integrations: {
      //     Amplitude: {
      //       'session_id': this.ampid
      //     }
      //   }
      // })
      // } else if (e === 100) {
      //     window.analytics.track('[Tabbar][Notification][seemore]', {}, {
      //     integrations: {
      //       Amplitude: {
      //         'session_id': this.ampid
      //       }
      //     }
      //   })
      // }
      this.countNoti = e;
      let count = 0;
      let notification = [];
      this.names = [];
      let response = await axios.post(apiUrl + "/api/query/notification", {
        command: "get"
      });
      let indextcca = await axios.post(apiUrl + "/api/query/getAllIndex", {
        id: this.user_id,
        command: "tcca"
      });
      let indexpdpa = await axios.post(apiUrl + "/api/query/getAllIndex", {
        id: this.user_id,
        command: "pdpa"
      });
      let noti = response.data.notification;
      noti.sort((a, b) => new Date(b.createdate) - new Date(a.createdate));
      this.badgeNoti = 0;
      noti.map(el => {
        if (!el.read) {
          this.badgeNoti += 1;
        }
        if (count < e) {
          let checktcca = indextcca.data.find(item => item === el.device);
          let checkpdpa = indexpdpa.data.find(item => item === el.device);
          let type = "";
          if (checktcca !== undefined) {
            type = "tcca";
          } else if (checkpdpa !== undefined) {
            type = "pdpa";
          } else if (el.type === "set") {
            type = "set";
          } else {
            type = "at";
          }
          count += 1;
          let datetime = new Date(el.createdate);
          let day = "";
          switch (datetime.getDay()) {
            case 1:
              day = "Mon";
              break;
            case 2:
              day = "Tue";
              break;
            case 3:
              day = "Wed";
              break;
            case 4:
              day = "Thu";
              break;
            case 5:
              day = "Fri";
              break;
            case 6:
              day = "Sat";
              break;
            case 0:
              day = "Sun";
              break;
          }
          let minutes = "";
          if (datetime.getMinutes() < 10) {
            minutes = `0${datetime.getMinutes()}`;
          } else {
            minutes = `${datetime.getMinutes()}`;
          }
          notification.push({
            _id: el._id,
            createdate: el.createdate,
            device: el.device,
            type: type,
            title: `${el.alertname.substring(
              0,
              25
            )} - ${day} ${datetime.getDate()} ${datetime.getHours()}:${minutes}`,
            description: `${el.description.substring(0, 40)}...`,
            read: el.read
          });
        }
      });
      // this.badgeNoti = 0
      // notification.map(el => {
      //     if (!el.read) {
      //       this.badgeNoti += 1
      //     }
      //   })
      // this.badgeNoti = noti.length
      this.names = notification;
    },
    shownNoticficationMore() {
      this.toSetNotification(100);
      this.clickNotification();
    },
    async clearNotification() {
      this.badgeNoti = 0;
      await axios.post(apiUrl + "/api/query/notification", {
        command: "readall"
      });
    },
    async delNotificationAll() {
      this.badgeNoti = 0;
      await axios.post(apiUrl + "/api/query/notification", {
        command: "delete"
      });
    },
    toHome() {
      if (this.$router.history.current.name === "dashboard") {
        this.$router.go();
      } else {
        this.toDashboard();
      }
    },
    toDashboard() {
      window.analytics.track(
        "[Menu]",
        {
          value: {
            menu: "iLogDashboard TCCA"
          }
        },
        {
          integrations: {
            Amplitude: {
              session_id: this.ampid
            }
          }
        }
      );
      this.toLog("dashboard");
      this.$router.push({
        name: "dashboard",
        params: { isExpired: this.isExpired }
      });
    },
    toAlertHistoryTCCA() {
      window.analytics.track(
        "[Menu]",
        {
          value: {
            menu: "Alert History TCCA"
          }
        },
        {
          integrations: {
            Amplitude: {
              session_id: this.ampid
            }
          }
        }
      );
      this.toLog("alertHistorytcca");
      this.$router.push({
        name: "alertHistorytcca",
        params: { isExpired: this.isExpired }
      });
    },
    todashboardPDPA() {
      window.analytics.track(
        "[Menu]",
        {
          value: {
            menu: "iLogDashboard PDPA"
          }
        },
        {
          integrations: {
            Amplitude: {
              session_id: this.ampid
            }
          }
        }
      );
      this.toLog("dashboardpdpa");
      this.$router.push({
        name: "dashboardpdpa",
        params: { isExpired: this.isExpired }
      });
    },
    toAlertHistoryPDPA() {
      window.analytics.track(
        "[Menu]",
        {
          value: {
            menu: "Alert History PDPA"
          }
        },
        {
          integrations: {
            Amplitude: {
              session_id: this.ampid
            }
          }
        }
      );
      this.toLog("alertHistorypdpa");
      this.$router.push({
        name: "alertHistorypdpa",
        params: { isExpired: this.isExpired }
      });
    },
    toWhitelist() {
      window.analytics.track(
        "[Menu]",
        {
          value: {
            menu: "Settings PDPA"
          }
        },
        {
          integrations: {
            Amplitude: {
              session_id: this.ampid
            }
          }
        }
      );
      this.toLog("whitelist");
      this.$router.push({
        name: "whiteList",
        params: { isExpired: this.isExpired }
      });
    },
    toAlert() {
      window.analytics.track(
        "[Menu]",
        {
          value: {
            menu: "Alert Condition"
          }
        },
        {
          integrations: {
            Amplitude: {
              session_id: this.ampid
            }
          }
        }
      );
      this.toLog("alert");
      this.names = [];
      this.$router.push({
        name: "alert",
        params: { isExpired: this.isExpired }
      });
    },
    toLicense() {
      window.analytics.track(
        "[Menu]",
        {
          value: {
            menu: "License"
          }
        },
        {
          integrations: {
            Amplitude: {
              session_id: this.ampid
            }
          }
        }
      );
      this.toLog("license");
      this.$router.push({
        name: "license",
        params: { isExpired: this.isExpired }
      });
    },
    toRequest() {
      window.analytics.track(
        "[Menu]",
        {
          value: {
            menu: "Request"
          }
        },
        {
          integrations: {
            Amplitude: {
              session_id: this.ampid
            }
          }
        }
      );
      this.toLog("request");
      this.$router.push({
        name: "request",
        params: { isExpired: this.isExpired }
      });
    },
    toReport() {
      window.analytics.track(
        "[Menu]",
        {
          value: {
            menu: "Report"
          }
        },
        {
          integrations: {
            Amplitude: {
              session_id: this.ampid
            }
          }
        }
      );
      this.toLog("report");
      this.$router.push({
        name: "report",
        params: { isExpired: this.isExpired }
      });
    },
    toSupport() {
      window.analytics.track(
        "[Menu]",
        {
          value: {
            menu: "Administrator"
          }
        },
        {
          integrations: {
            Amplitude: {
              session_id: this.ampid
            }
          }
        }
      );
      this.toLog("support");
      this.$router.push({
        name: "support",
        params: { isExpired: this.isExpired }
      });
    },
    toSearch() {
      window.analytics.track(
        "[Menu]",
        {
          value: {
            menu: "search"
          }
        },
        {
          integrations: {
            Amplitude: {
              session_id: this.ampid
            }
          }
        }
      );
      this.toLog("search");
      this.$router.push({ name: "raw", params: { isExpired: this.isExpired } });
    },
    setNev() {
      setTimeout(() => {
        this.toSetNotification(8);
      }, 1500);
      let ilogpath = this.$router.history.current.name;
      switch (ilogpath) {
        case "dashboard":
          this.navMenu = "iLog";
          break;
        case "alertHistorytcca":
          this.navMenu = "iLog";
          break;
        case "dashboardpdpa":
          this.navMenu = "iLog PDPA";
          break;
        case "alertHistorypdpa":
          this.navMenu = "iLog PDPA";
          break;
        case "whiteList":
          this.navMenu = "iLog PDPA";
          break;
        case "raw":
          this.navMenu = "Search";
          break;
        case "alert":
          this.navMenu = "Alert Condition";
          break;
        case "license":
          this.navMenu = "License";
          break;
        case "request":
          this.navMenu = "Request Feature";
          break;
        case "report":
          this.navMenu = "Report Problem";
          break;
        default:
          this.navMenu = "iLog";
          break;
      }
    },
    toLog(methods) {
      setTimeout(() => {
        this.setNev();
      }, 100);
      axios.post(apiUrl + "/api/dashboard/stage", {
        type: "menu",
        username: this.username,
        menu: methods
      });
    },
    leaving(event) {
      window.analytics.track(`[RefreshBowser]`, event, {
        integrations: {
          Amplitude: {
            session_id: this.ampid
          }
        }
      });
      axios.post(apiUrl + "/api/dashboard/stage", {
        type: "bowser",
        username: this.username,
        action: "RefreshBowser"
      });
    },
    async finishStepTour() {
      await axios.post(apiUrl + "/api/status/recommend", {
        command: "disdashbordtcca"
      });
    }
  },
  watch: {
    drawer: function() {
      if (this.drawer) {
        window.analytics.track(
          "[Menu]",
          {
            value: {
              menu: "button"
            }
          },
          {
            integrations: {
              Amplitude: {
                session_id: this.ampid
              }
            }
          }
        );
      }
    },
    recommend: function() {
      if (this.recommend && this.$router.history.current.name === "dashboard") {
        setTimeout(() => {
          this.$tours["recommand-tour"].start();
        }, 1500);
      }
    }
  }
};
</script>

<style scoped>
#space-menu {
  margin: 25px auto;
}
#group_logo_menu {
  /* margin: 10px 70px; */
  padding: 0;
  margin-left: 70px;
  /* margin-bottom: 20px; */
}

#group_logo_menu > span {
  margin-left: 6px;
  color: #bbb;
  font-size: 18px;
}

#ilog_logo_menu {
  width: 50px;
  height: 50px;
  margin-top: 10px;
  margin-left: 6px;
}

#group_menu {
  /* margin: 5px 15px; */
  margin-top: 20px;
  margin-left: 15px;
  font-size: 15px;
  color: #bbb;
}
#nav-bar {
  max-width: 220px;
  background-color: #292728;
}
#tool-bar {
  background-color: #292728;
}

#chip {
  font-size: 11px;
  color: white;
}

.submenu {
  font-size: 13px;
  font-weight: 300;
}

#content {
  background-color: #0d0f11;
  height: auto !important;
  min-height: 100%;
}

.tile {
  margin: 5px;
  border-radius: 4px;
}
.tile:hover {
  background: #424242;
}
.tile:active {
  background: #757575;
}

.card-ft {
  border-radius: 13px;
  margin: 0 auto;
  /* background: none !important;
  border: none !important;
  box-shadow: none !important; */
  background-color: red;
}

.contactus {
  width: 800px;
  height: 500px;
  background-color: #263238 !important;
  border-radius: 18px;
  /* background-image: url('../assets/img/contact/6.jpg');
  background-position: center;
  background-size: cover;
  filter: opacity(90%) */
}
.img-contact {
  /* width: 380px;
  height: 300px;
  position: absolute;
  right: 0px;
  bottom: 0px; */

  width: 250px;
  height: 260px;
  position: absolute;
  right: 9px;
  bottom: 0px;
  filter: drop-shadow(0 0 0.6rem #212121);
}
.icon-contactus {
  color: #eeeeee !important;
}
.title-contact {
  position: relative;
  z-index: 1;
  color: #eeeeee;
  margin-left: 8px;
  margin-top: 7px;
}
.detail-contact {
  position: relative;
  z-index: 1;
  color: #eeeeee;
  margin-left: 8px;
  margin-top: 7px;
}
.v-tour__target--highlighted {
  box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.8) !important;
}
.tour-body {
  max-width: 900px !important;
  min-width: 400px !important;
  max-height: 300px !important;
  padding: 0 !important;
  margin: auto !important;
  background-color: #212121 !important;
}
.tour-btn-start {
  color: #fff !important;
  background-color: #009688 !important;
  box-shadow: none !important;
  border-radius: 13px !important;
  width: 260px !important;
  outline: none !important;
  margin: 0 auto !important;
  margin-top: 10px !important;
  text-transform: none !important;
  font-size: 16px !important;
}
.tour-btn-skip {
  position: relative !important;
  left: 160px !important;
  text-transform: none !important;
  outline: none !important;
  font-size: 13px !important;
  margin: 10px 0 !important;
  color: #616161 !important;
  text-decoration-line: underline !important;
  font-style: normal !important;
  font-weight: normal !important;
}
.tour-btn-back {
  margin: 0 10px !important;
  color: #212121 !important;
  outline: none !important;
  background-color: #fff !important;
  text-transform: none !important;
  box-shadow: none !important;
  border-radius: 13px !important;
}
.tour-btn-next {
  margin: 0 10px;
  color: #fff !important;
  outline: none !important;
  background-color: #009688 !important;
  text-transform: none !important;
  box-shadow: none !important;
  border-radius: 13px !important;
}
.tour-btn-finish {
  color: #fff !important;
  outline: none !important;
  background-color: #009688 !important;
  text-transform: none !important;
  box-shadow: none !important;
  border-radius: 13px !important;
  width: 25px !important;
  margin: 20px auto;
}
.tour-header {
  border-bottom: 1px solid #bdbdbd !important;
  margin: 12px 30px !important;
  padding: 0 !important;
}
.tour-content {
  font-size: 14px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/layout.vue